module.exports = __webpack_public_path__ + "img/36.05c3c5bf.jpg";